import wrapWithProvider from "./src/wrap-with-provider";
export const wrapRootElement = wrapWithProvider;
